<script lang="ts">
	import type { Device, DeviceRawData } from "luxedo-data"
	import { viewDevice } from "../../../modules/page-events/navigator"

	interface Props {
		device: DeviceRawData | Device
	}

	let { device }: Props = $props()

	function handleClick() {
		viewDevice(device.id)
	}
</script>

<tr
	role="button"
	onclick={handleClick}
	onkeypress={(e) => {
		if (e.key === "Enter") handleClick()
	}}
>
	<td>{device.id}</td>
	<td>{device.name}</td>
	<td>{device.status}</td>
</tr>

<style>
	tr {
		cursor: pointer;
		transition:
			background-color var(--transition-duration),
			color var(--transition-duration);
	}

	tr td:first-of-type {
		padding-left: 1rem;
		max-width: 2rem;
		border-top-left-radius: var(--br);
		border-bottom-left-radius: var(--br);
	}

	tr td:last-of-type {
		padding-right: 1rem;
		border-top-right-radius: var(--br);
		border-bottom-right-radius: var(--br);
	}

	tr:focus-visible,
	tr:hover {
		background-color: var(--color-accent);
		color: var(--color-text-light);
	}
</style>
